import { Component } from 'react';
import {
    IllustrationCallout,
    ILLUSTRATION_CALLOUT_SIZES,
} from '@Green-Dot-Corporation/eureka-ui-callouts';
import { VARIANTS } from '@Green-Dot-Corporation/eureka-ui-buttons';
import { withRouter } from '@Green-Dot-Corporation/eureka-lib-router-utils';
import WarningAlert from './components/svg/Warning';
import CustomError from './CustomError';
import { clearAccessToken } from './utils/serviceUtils';
import './styles/error-boundary.scss';

const { SMALL } = ILLUSTRATION_CALLOUT_SIZES;

class ErrorBoundary extends Component {
    state = {};

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        this.setState({ error });
    }

    render() {
        const { children } = this.props;
        const { hasError, error = {} } = this.state;
        const { errorObject = new CustomError().errorObject } = error;
        const { title, msg, buttonText } = errorObject;

        const actions = [
            {
                variant: VARIANTS.PRIMARY,
                text: buttonText,
            },
        ];

        // this is the page
        if (hasError) {
            return (
                <div className={this.baseCls} data-ae-view="error">
                    <IllustrationCallout
                        headingLvl={1}
                        illustrationSize={SMALL}
                        isPageHeading
                        title={title}
                        msg={msg}
                        renderIllustration={this.renderIllustration}
                        actions={actions}
                        onActionClick={this.handleButtonClick}
                    />
                </div>
            );
        }

        return children;
    }

    renderIllustration = () => <WarningAlert />;

    handleButtonClick = () => {
        const { error = {} } = this.state;
        const { errorObject } = error;
        const url = errorObject?.error?.errorDetails?.responseData?.errorUrl;
        clearAccessToken();
        window.location.href = url;
    };

    baseCls = 'card-mgmt-error-boundary';
}

export default withRouter(ErrorBoundary);

// https://medium.com/trabe/catching-asynchronous-errors-in-react-using-error-boundaries-5e8a5fd7b971
// use setState(() => { throw new Error() }) to have it caught by ErrorBoundary
